/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { useIntl } from 'react-intl'
import { KTSVG } from '../../../../helpers'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'
import { useAuth } from '../../../../../app/modules/auth'
import { AbilityContext, Can } from '../../../../common/rbac/Can'

import { useAbility } from '@casl/react'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const user: any = useAuth()
  const ability = useAbility(AbilityContext)

  return (
    <>
      {/* <SidebarMenuItem
        to='/dashboard'
        icon='/media/svg/menu/home1.svg'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      /> */}

      <SidebarMenuItem
        to='/dashboard'
        icon='/media/svg/menu/dashboard.svg'
        title='Dashboard'
        fontIcon='bi-layers'
      />

      <SidebarMenuItem
        to='/chats'
        icon='/media/svg/menu/chats.svg'
        title='Chats'
        fontIcon='bi-layers'
      />

      <SidebarMenuItem
        to='/users'
        icon='/media/svg/menu/users.svg'
        title='Users'
        fontIcon='bi-layers'
      />

      <SidebarMenuItem
        to='/triggers'
        icon='/media/svg/menu/trii.svg'
        title='Triggers'
        fontIcon='bi-layers'
      />

      {ability.can('manage', 'companies') && (
        <SidebarMenuItem
          to='/companies'
          icon='/media/svg/menu/company.svg'
          title='Companies'
          fontIcon='bi-layers'
        />
      )}

      {ability.can('manage', 'companies') && ability.can('manage', 'users') && (
        <SidebarMenuItem
          to='/roles'
          icon='/media/svg/menu/roles.svg'
          title='Roles'
          fontIcon='bi-layers'
        />
      )}

      <SidebarMenuItem
        to='/training'
        icon='/media/svg/menu/chatgpt.svg'
        title='Training'
        fontIcon='bi-layers'
      />

      <SidebarMenuItem
        to='/automations'
        icon='/media/svg/menu/auto.svg'
        title='Automations'
        fontIcon='bi-layers'
      />

      <SidebarMenuItem
        to='/settings'
        icon='/media/svg/menu/settings.svg'
        title='Settings'
        fontIcon='bi-layers'
      />
    </>
  )
}

export { SidebarMenuMain }
